export default {
  status: {
    open: 'Deschis',
    closed: 'Închis',
  },
  offline_until: 'Offline până la',
  closed_until: 'Închis până la',
  online_orders_paused: 'Comenzi online suspendate',
  online_orders_paused_until: 'Comenzi online suspendate până la',
  reopens: 'Se redeschide',
  opens_today: 'Se deschide azi',
  opens: 'Se deschide',
  open: 'Deschis',
  open_whole_day: 'Deschis toată ziua',
  outside_ordering_times: 'În afara orelor de comandă',
};
